<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-18 09:41:33
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-12-27 14:03:14
-->
<template>
  <div class="innovative">
    <router-view />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      fixed: true
    }
  },
  computed: {
    ...mapGetters(['device', 'language'])
  },
  mounted () {
  },
  methods: {
  },
  destroyed () {
  }
}
</script>
<style lang="less" scoped>
.en.m .innovative {
  .innovative-bj {
    position: relative;
    .job-bj-txt {
      text-align: center;
    }
    .innovative-bj-title {
      font-size: 30px;
      line-height: 98px;
      position: relative;
      color: #ffffff;
      top: -14px;
      left: -6px;
      &::after {
        content: '';
        width: 200px;
        height: 2px;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 48%, rgba(255, 255, 255, 0) 100%);
        position: absolute;
        bottom: 0;
        left: calc(50% - 100px);
      }
    }
    .innovative-bj-des {
      font-size: 20px;
      left: 160px;
      padding-top: 10px;
      color: rgba(255, 255, 255, 0.5);
    }
  }
  .innovative-content {
    color: #333333;
    // padding-top: 22px;
    padding-bottom: 100px;
    position: relative;
    .innovative-detail {
      min-height: 80vh;
    }
    .innovative-type {
      height: 100px;
      line-height: 100px;
      font-size: 24px;
      font-weight: 600;
      z-index: 2;
      bottom: 0;
      background: #ffffff;
      border-top: 2px solid rgba(216, 216, 216, 0.4);
      .innovative-type-box {
        white-space: nowrap;
        transition: transform .3s;
        position: relative;
      }
      .innovative-type-item {
        // padding: 0 60px;
        cursor: pointer;
        font-weight: bold;
        text-align: center;
        &.active {
          color: #00A0E9;
        }
      }
      .active-bar {
        position: absolute;
        bottom: -2px;
        left: 0;
        height: 2px;
        background-color: #008ACA;
        z-index: 1;
        transition: transform .3s cubic-bezier(.645,.045,.355,1);
        list-style: none;
      }
    }
  }
}

.en.pc {
  .innovative {
    .innovative-bj {
      position: relative;
      .job-bj-txt {
        text-align: center;
      }
      .innovative-bj-title {
        font-size: 40PX;
        line-height: 98PX;
        position: relative;
        color: #ffffff;
        top: -14PX;
        left: -6PX;
        &::after {
          content: '';
          width: 200PX;
          height: 2PX;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 48%, rgba(255, 255, 255, 0) 100%);
          position: absolute;
          bottom: 0;
          left: calc(50% - 100PX);
        }
      }
      .innovative-bj-des {
        font-size: 20PX;
        left: 160PX;
        padding-top: 10PX;
        color: rgba(255, 255, 255, 0.5);
      }
    }
    .innovative-content {
      color: #333333;
      padding-top: 22PX;
    }
  }
}
</style>
